import axios from "axios";

export const crowdin = axios.create({
  baseURL: "https://api.crowdin.com/api/v2",
  headers: {
    Authorization: `Bearer 9dae1906b47aedd02fbdd59f208dc15434fe14bc46eb8cd4f5f950ec8e20faf3dc3fd295939638c8`,
  },
});
